import { FadeUp, Eyebrow } from "./motion";
import { useContent } from "../lib/content";

export default function Collections() {
  const { collections } = useContent();

  return (
    <section id="collections" data-testid="collections-section" className="py-20 sm:py-28 bg-sand-soft/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <FadeUp className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Eyebrow className="mb-4">Our collections</Eyebrow>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900 max-w-xl">
              Premium curtain collections for <span className="italic text-reef">every space.</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm sm:text-base text-slate-600 leading-relaxed">
            From modern blackout curtains to elegant sheer designs — quality, comfort and
            sophistication for homes, offices and commercial spaces.
          </p>
        </FadeUp>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {collections.map((c, i) => (
            <FadeUp key={i} delay={i * 0.08} className={i % 2 === 1 ? "lg:mt-12" : ""}>
              <div data-testid={`collection-card-${i}`} className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-2xl aspect-[3/4] border border-sand-border">
                  <img
                    src={c.img}
                    alt={`${c.name} curtains Dubai`}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-reef/0 group-hover:bg-reef/15 transition-colors duration-500" />
                  <span className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.2em] uppercase bg-white/85 backdrop-blur px-3 py-1.5 rounded-full text-reef">
                    {c.tag}
                  </span>
                </div>
                <div className="mt-4 flex items-baseline justify-between">
                  <h3 className="font-serif text-xl text-slate-900">{c.name}</h3>
                  <span className="font-mono text-xs text-reef/50">0{i + 1}</span>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
